import { OnInit } from '@angular/core';
import { Component } from '@angular/core';

@Component({
    template: require('./notFound.component.html'),
    styles: [require('./notFound.component.less')],
    preserveWhitespaces: true
})

export class NotFoundComponent implements OnInit {
    isPatientAppView: boolean = false;
    constructor(
    ) { }

    ngOnInit(
    ) {
    }
}
